import { TAppNotificationParams } from '@src/providers/App';

type TNotificationFn = (fioEmail?: string) => TAppNotificationParams;
export type TSessionNotificationType = 'ACCOUNT_IS_BLOCKED' | 'DE_AUTH_KEY_INVALID' | 'COMMON_ERROR';

const ACCOUNT_IS_BLOCKED: TNotificationFn = (fioEmail) => ({
  view: 'error',
  title: 'Нет доступа к аккаунту',
  content: `У вас нет доступа к аккаунту ${fioEmail}`,
});

const DE_AUTH_KEY_INVALID: TNotificationFn = (fioEmail) => ({
  view: 'warning',
  title: 'Вы были авторизованы в другой аккаунт',
  content: `Вы деавторизованы из аккаунта ${fioEmail}`,
});

const COMMON_ERROR: TNotificationFn = () => ({
  view: 'error',
  title: 'Ошибка',
  content: `При попытке сменить аккаунт возникла ошибка`,
});

/** Разделил для лучшей поддержки типизации */
export const NOTIFICATION_ERROR_DATA = {
  ACCOUNT_IS_BLOCKED,
  DE_AUTH_KEY_INVALID,
  COMMON_ERROR,
};
